export default function menuOpen() {
    var burgerButton = document.querySelector('.gh-burger');
    if (burgerButton) {
        burgerButton.addEventListener('click', function () {
            document.body.classList.toggle('gh-head-open');
        });
    }
}
